export default "__VITE_ASSET__Nb0QPp98__"